//Live API Details
export const APIS = {
  api_dev: "https://jobeval.rhbcgroup.com/api/v1",
  api_report: "https://jobeval.rhbcgroup.com/",
};

// //Live API Details
// export const APIS = {
//   api_dev: "http://13.126.27.99:9193/api/v1",
//   api_report: "http://13.126.27.99:9193/",
// };

// Production API Details
// export const APIS = {
//   api_dev: "https://jobeval.nextpagetechnologies.com/api/v1",
//   api_report: "https://jobeval.nextpagetechnologies.com/",
// };

//Local API Details
// export const APIS = {
//   api_dev: "http://localhost:8084/api/v1",
//   api_report: "http://localhost:8084/",
// };

const apisConfig = { APIS };

export default apisConfig;
